<template>
  <div v-if="businessRegistrationData">
    <v-card>
      <v-card-title>
        <div>ویرایش اطلاعات کسب و کار</div>
        <v-spacer></v-spacer>
        <v-btn color="error" icon @click="closeEditForm()">
          <v-icon>mdi mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <business-registration
          :isEdit="true"
          :businessRegistrationData="businessRegistrationData"
          :merchantMonitorFields="merchantMonitorFields"
          @closeForm="closeEditForm"
          :editMerchant="true"
        ></business-registration>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Helper from '@/core/helpers';
import Swal from 'sweetalert2';
import { RepoFactory } from '@/baseRepository/Factory';
const merchantCompanyRepository = () => RepoFactory.get('merchantCompany');
import BusinessRegistration from '@/components/businessInformation/form/BusinessRegistration.vue';
export default {
  components: {
    BusinessRegistration,
  },
  data() {
    return {
      backButtonPrevented:false,
      businessRegistrationData: null,
      merchantMonitorFields: null,
    };
  },
  computed: {
    ...mapGetters(['merchantBaseUrl']),
  },
  mounted(){
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', this.popStateListener);
  },
  destroyed(){
    this.backButtonPrevented = true;
    this.popStateListener();
  },
  created() {
    this.getMerchantInformationById();
  },
  methods: {
    popStateListener(event) {
  if (this.backButtonPrevented === false){
    history.pushState(null, document.title, location.href);
  Swal.fire({
        html: `شما در حال ترک عملیات نا تمام هستید و اطلاعات ثبت شده از بین خواهد رفت. آیا مطمئن به ترک این بخش بدون اتمام عملیات هستید؟`,
        icon: 'warning',
        confirmButtonText: ' بلی',
        showCancelButton: true,
        cancelButtonText: 'خیر',
        reverseButtons: true,
      }).then((result) => {
        if(result.value){
          window.removeEventListener('popstate', this.popStateListener);
         this.closeEditForm();
        }
        
      });
  } else {
      window.removeEventListener('popstate', this.popStateListener);
      // history.back();
  }
},
    closeEditForm() {
      this.$router.push({
        path: `/merchant-companies/${this.businessRegistrationData.merchantId}/information`,
      });
    },
    getMerchantInformationById() {
      const loader = this.$loading.show();
      merchantCompanyRepository()
        .getMerchantInformationById(this.$route.params.id, this.merchantBaseUrl)
        .then(({ data }) => {
          if (data.status == 'Approved') {
            this.getMerchantMonitorFields();
          }
          this.businessRegistrationData = data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    getMerchantMonitorFields() {
      const loader = this.$loading.show();
      merchantCompanyRepository()
        .getMerchantMonitorFields(this.merchantBaseUrl)
        .then(({ data }) => {
          this.merchantMonitorFields = data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style></style>
